const QUERY_KEYS = {
  me: ['me'],

  project: {
    list: (params = {}) => ['userProjects', params],
    details: (id) => ['project', 'details', id],
    headerProjects: () => ['headerProjects'],
    assignedProjects: (page, perPage) => ['assignedProjects', page, perPage],
    current: (id) => ['currentProject', id],
    aiAccess: (projectId, featureKey) => ['project', projectId, 'ai-access', featureKey],
    projectsByRole: () => ['projectsByRole'],
    repositoryTrend: (projectId, dateFilter) => [
      'project',
      projectId,
      'repository-trend',
      dateFilter,
    ],
    testCaseSummary: (projectId, dateFilter) => [
    'project',
    projectId,
    'test-case-summary',
    dateFilter,
  ],
    repositoryHealthInsights: (projectId) => ['dashboard', 'repository-health-insights', projectId],
    moduleCoverageInsights: (projectId) => ['dashboard', 'module-coverage-insights', projectId],
    redundancyInsights: (projectId) => ['dashboard', 'redundancy-insights', projectId],
    redundancyDataset: (projectId, dataset, page, perPage) => [
      'dashboard',
      'redundancy-insights',
      projectId,
      dataset,
      page,
      perPage,
    ],
    aiInsights: (projectId, dateFilter) => ['dashboard', 'ai-insights', projectId, dateFilter],
    orphanTestCycleInsights: (projectId) => ['project', projectId, 'orphan-test-cycle-insights'],
  },

  users: {
    list: (params = {}) => ['users', params],
    details: (userId) => ['user', userId],
    headerUsers: (params = {}) => ['headerUsers', params],
    projectAccess: () => ['userProjectAccess'],
  },

  testCase: {
    list: (projectId) => ['testcases', projectId],
    details: (testCaseId) => ['testcase', testCaseId],
    linkedIssues: (testCaseId) => ['linkedIssues', testCaseId],
  },

  testCycle: {
    list: () => ['testcycles'],
    listWithParams: (params) => ['testcycles', params],
    details: (id) => ['testcycle', id],
    linkedIssues: (id) => ['linkedIssues', id],
  },

  dashboard: {
    stats: () => ['dashboard', 'stats'],
    defectsOverview: (projectIds, isDashboard) => ['defectsOverview', projectIds, isDashboard],
  },

  projectDashboard: {
    defectsLogged: (projectId, jiraProjectId) => ['defectsLogged', projectId, jiraProjectId],
  },

  issues: {
    list: (params = {}) => ['issues', params],
    details: (issueId) => ['issue', issueId],
  },
};

export default QUERY_KEYS;
